import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { map, of, tap } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.isLoggedIn()
    .pipe(tap(
      loggedIn => {
        if (!loggedIn) {
          authService.logout();
        }
      }));
};

export const unauthGuard: CanActivateFn = (route, stae) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.isLoggedIn()
    .pipe(tap(
      loggedIn => {
        if (loggedIn) {
          router.navigate(['/']);
        }
      }),
      map(loggedIn => {
        return !loggedIn;
      }));
}
